<template>
  <b-card>
    <b-row
      align-h="end"
      style="gap: 1rem; margin-bottom: 10px;"
    >
      <b-col>
        <b-badge
          variant="light-warning"
          style="margin-bottom: 0px; padding: 10px; white-space: normal;"
        >
          Algumas filiais não são exibidas devido ao fato de terem as mesmas mensagens na Caixa Postal que a Matriz cadastrada.
        </b-badge>
      </b-col>
    </b-row>
    <caixapostal-list
      id="caixapostalList"
      ref="caixapostalList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
      :tem-filtro-extra="isFiltroNovoNoMonitor"
      ultima-rota="mensagem-view"
      filtro-de-holder="Data inicial de envio"
      filtro-para-holder="Data final de envio"
      filtro-de-para
      :tem-limpar-filtros="true"
    >
      <template slot="filtro-extra"
        v-if="isFiltroNovoNoMonitor"
      >
        <filtro-rapido
          ref="filtroRapido"
          :filtros="filtroRapidoSecundario"
          :filtro-atual="filtroAtualSecundario"
          filtro-nome="Periodo mensagem nova"
          @selecionado="$refs.caixapostalList.aplicarFiltroRapido({...$event, queryName: 'dias', colunas: ['NovasNoMonitorSecundario'] }, false)"
        />
      </template>

      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <span
          v-if="['consultadoEm', 'cadastroFederal', 'razaoSocial'].includes(props.column.field)"
          @click.stop="props.column.field === 'razaoSocial' && visualizarTodasMsg(props.row)"
          style="display: flex; justify-content: space-between; align-items: center; position: relative;"
        >
          <span
            :style="{
              fontWeight: props.row.mensagemLida === false ? 'bold' : 'normal',
              wordBreak: 'break-word',
              flex: 1
            }"
          >
            {{ props.formattedRow[props.column.field] }}
          </span>

          <b-badge
            v-if="props.column.field === 'razaoSocial' && props.row.mensagemLida === false && props.row.mensagemNova !== '-'"
            :style="{
              backgroundColor:
                props.row.mensagemNova === 'amarelo'
                  ? 'rgba(217, 175, 11, 0.3)'   // amarelo translúcido
                  : props.row.mensagemNova === 'azul'
                  ? 'rgba(16, 69, 171, 0.3)'    // azul translúcido
                  : props.row.mensagemNova === 'vermelho'
                  ? 'rgba(220, 53, 69, 0.3)'    // vermelho translúcido
                  : 'rgba(108, 117, 125, 0.3)', // cinza translúcido
              color:
                props.row.mensagemNova === 'amarelo'
                  ? '#b48a00'
                  : props.row.mensagemNova === 'azul'
                  ? '#0d2e91'
                  : props.row.mensagemNova === 'vermelho'
                  ? '#b8222d'
                  : '#4a4a4a',
              fontSize: '0.8rem',
              padding: '0.2rem 0.4rem',
              lineHeight: '1',
              borderRadius: '0.25rem',
              marginLeft: '6px',
              whiteSpace: 'nowrap'
            }"
            class="badge-size-p"
          >
            Nova no Monitor
          </b-badge>
        </span>
        <div
          v-if="props.column.field === 'qtdNaoLidas'"
          class="d-block"
          :class="{ 'font-weight-bold': props.row.mensagemLida === false }"
        >
          <b-badge
            v-if="props.row['nenhumaMsg']"
            variant="light-success"
          >
            Sem mensagens
          </b-badge>
          <b-badge
            v-else-if="props.row['qtdNaoLidas'] > 0"
            variant="light-warning"
          >
            {{ props.row['qtdNaoLidas'] }} {{ props.row['qtdNaoLidas'] > 1 ? 'não lidos' : ' não lido' }}
          </b-badge>
          <b-badge
            v-else
            variant="light-success"
          >
            Todas lidas
          </b-badge>
        </div>
      </template>
      <template
        slot="acoes"
        slot-scope="{ props} "
      >
        <b-btn
          v-b-tooltip.hover
          title="Visualizar todas as mensagens"
          variant="none"
          class="btn btn-none rounded-pill mr-50"
          style="padding: 0.4rem;"
          :disabled="props.row.nenhumaMsg"
          @click="visualizarTodasMsg(props.row)"
        >
          <font-awesome-icon
            icon="fa-solid fa-envelopes-bulk"
            class="text-primary"
            size="lg"
          />
        </b-btn>
      </template>
    </caixapostal-list>
  </b-card>
</template>

<style lang="scss">
.modal-lg {
  max-width: 1000px !important;
}

.data-width {
  width: 120px !important;
}
.caixapostal-td-acao {
  // min-width: 0.5rem;
  width: 12px;
}
</style>

<script>

import colunas from './shared/components/colunas'
import api from './shared/services/api'

export default {
  name: 'CaixaPostalVisualizacao',
  components: {
    CaixapostalList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    FiltroRapido: () => import('@pilar/components/visualizacao-base/components/filtro-rapido/FiltroRapido.vue'),
  },
  data() {
    return {
      filtroAtualSecundario: null,
      isFiltroNovoNoMonitor: false,
      botoesOption: null,
      linha: null,
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social ou Assunto',
        acaoClass: 'caixapostal-td-acao',
        disabledCheckbox: true,
      },
      filtros: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial', 'Assunto', 'ConsultadoEm'], valor: null }],
      filtroRapidoSecundario: [
        {
          id: 'Ate7',
          label: 'Até 7 dias',
          valor: true,
        },
        {
          id: '7a15',
          label: '8 à 15 dias',
          valor: true,
        },
        {
          id: 'Acima15',
          label: 'Acima de 15',
          valor: true,
        },
      ],
      filtrosRapidos: [
        {
          id: 'Pronampe',
          colunas: ['TipoMensagem'],
          label: 'Pronampe',
          valor: '2',
        },
        {
          id: 'MalhaFiscal',
          colunas: ['TipoMensagem'],
          label: 'Malha fiscal',
          valor: '1',
        },
        {
          id: 'TermoIntimacao',
          colunas: ['TipoMensagem'],
          label: 'Termo de intimação',
          valor: '3',
        },
        {
          id: 'TermoIntimacaoNaoLida',
          colunas: ['IntimacaoNaoLida'],
          label: 'Termo(s) de Intimação não lidas',
          valor: true,
        },
        {
          id: 'TermoIntimacaoLida',
          colunas: ['IntimacaoLida'],
          label: 'Termo(s) de Intimação lidas',
          valor: true,
        },
        {
          id: 'TermoExclusao',
          colunas: ['TipoMensagem'],
          label: 'Termo de exclusão',
          valor: '4',
        },
        {
          id: 'TermoIndeferimento',
          colunas: ['TipoMensagem'],
          label: 'Termo de indeferimento',
          valor: '5',
        },
        {
          id: 'Lidas',
          colunas: ['Lidas'],
          label: 'Lidas',
          valor: true,
        },
        {
          id: 'NaoLidas',
          colunas: ['NaoLidas'],
          label: 'Não lidas',
          valor: false,
        },
        {
          id: 'Relevante',
          colunas: ['Relevante'],
          label: 'Relevantes',
          valor: true,
        },
        {
          id: 'RelevanteNaoLido',
          colunas: ['RelevanteNaoLido'],
          label: 'Relevantes Não Lidas',
          valor: true,
        },
        {
          id: 'SemMensagem',
          colunas: ['Assunto'],
          label: 'Sem mensagens',
          valor: 'Contribuinte não possui mensagens em sua caixa postal.',
        },
        {
          id: 'EProcesso',
          colunas: ['EProcesso'],
          label: 'e-Processos',
          valor: true,
        },
        {
          id: 'EProcessoNaoLida',
          colunas: ['EProcessoNaoLida'],
          label: 'e-Processos não lidas',
          valor: true,
        },
        {
          id: 'PossuiObservacao',
          colunas: ['PossuiObservacao'],
          label: 'Possui observação',
          valor: true,
        },
        {
          id: 'NovasNoMonitor',
          colunas: ['NovasNoMonitor'],
          label: 'Novas no Monitor',
          valor: false,
        },
      ],
    }
  },
  created() {
    this.visualizacao.colunas = colunas
    this.visualizacao.colunas[0].evento = this.visualizarTodasMsg
    this.visualizacao.evento = this.carregar
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  methods: {
    /* eslint-disable no-param-reassign */
    carregar(pagina, tamanhoPagina, filtros) {
      const filtrosBy = filtros.filtroBy || null
      this.ativarFiltroRapidoSecundario(filtrosBy)

      return api.getPaginado(pagina, tamanhoPagina, filtros)
    },
    visualizarTodasMsg(row) {
      if (!row.nenhumaMsg) {
        this.$router.push({
          name: 'mensagem-view',
          query: {
            busca: this.$route.query.busca || '',
            filtroRapido: this.$route.query.filtroRapido ? this.$route.query.filtroRapido : '',
            dias: this.$route.query.dias ?? '',
            dataInicio: this.$route.query.dataInicio ? this.$route.query.dataInicio : '',
            dataFim: this.$route.query.dataFim ? this.$route.query.dataFim : '',
          },
          params: { id: row.id, nome: row.razaoSocial },
        })
      }
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.caixapostalList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.caixapostalList.aplicarFiltro(params.busca, filtroRapido)

          setTimeout(() => {
            this.filtroAtualSecundario = params.dias
              ? this.filtroRapidoSecundario.find(f => f.id === params.dias)
              : null
          }, 300)
        }
      })
    },
    ativarFiltroRapidoSecundario(filtros) {
      this.isFiltroNovoNoMonitor = filtros?.some(a => a.id === 'NovasNoMonitor') || false
    },
  },
}
</script>
